export default "__VITE_ASSET__38c05c7f__"